import { render, staticRenderFns } from "./Size.vue?vue&type=template&id=6ca03496&scoped=true"
var script = {}
import style0 from "./Size.vue?vue&type=style&index=0&id=6ca03496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca03496",
  null
  
)

export default component.exports